import { Box, Chip, Stack, Typography } from "@mui/material";
import React from "react";
import { HeadingWithChipsProps } from "../../interfaces";
import first from "../../assets/questions/first.png";
import second from "../../assets/questions/left.png";
import third from "../../assets/favicon.png";
import Button from '../common/Button';

const HeadingWithChips: React.FC<HeadingWithChipsProps> = ({
    // Main heading defaults
    headingPrefix = "You can ",
    headingHighlight = "count",
    headingSuffix = " on us",
    headingColor = "darkPurple.500",
    headingVariant = "h1",
    highlightColor = "lightPurple.500",
    
    // Subheading defaults
    subheading = "NO MATTER YOUR INDUSTRY, SMOOTH AND SECURE PAYMENTS ARE ESSENTIAL.",
    subheadingColor = "gray.400",
  
    // Discussion text defaults
    discussionText = ["LET'S ", " THE BEST PAYMENT STRATEGY FOR ", ""],
    chips = [
      { text: "DISCUSS", backgroundColor: "beige.200", textColor: "#beige.700" },
      { text: "YOUR BUSINESS", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" }
    ],
    discussionColor = "gray.400",
    sectionSize={xs: 343, sm: 500, md: 764},
  
    // Button properties
    showButton = false,
    buttonText = "CONTACT US",
    buttonHref = "/contact",
    buttonVariant = "lightPurple",

    // Styling defaults
    maxWidth = "1320px",
    padding = 8,
    displayIcons = true
  }) => {
    return (
      <Box sx={{ maxWidth, margin: "0 auto", py: padding }}>
        <Stack
          direction="column"
          spacing={8}
          alignItems="center"
          justifyContent="center"
        >
          {/* Heading */}
          <Typography
            variant={headingVariant}
            align="center"
            textTransform="uppercase"
            fontStyle="normal"
            lineHeight={1.2}
          >
            <Box component="span" sx={{ color: headingColor }} dangerouslySetInnerHTML={{ __html: headingPrefix }}/>
            <Box component="span" sx={{ color: highlightColor }} dangerouslySetInnerHTML={{ __html: headingHighlight }}/>
            <Box component="span" sx={{ color: headingColor }} dangerouslySetInnerHTML={{ __html: headingSuffix }}/>
          </Typography>
  
          {/* Subheading */}
          <Stack spacing={3} alignItems="center">
            <Typography
              align="center"
              variant="subtitle3"
              sx={{
                color: subheadingColor,
                whiteSpace: "pre-line"
              }}
            >
              <Box component="span" dangerouslySetInnerHTML={{ __html: subheading }}/>
            </Typography>
  
            {/* Discussion Section */}
            <Stack spacing={1} alignItems="center" >
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" justifyContent="center">
                <Typography
                  variant="subtitle11"
                  sx={{ color: discussionColor, maxWidth: sectionSize }}
                  textAlign="center"
                >
                  <Box component="span" dangerouslySetInnerHTML={{ __html: discussionText[0] }}/>
                  {chips.map((chip, index) => (
                    <React.Fragment key={index}>
                      <Chip
                        label={chip.text}
                        sx={{
                          backgroundColor: chip.backgroundColor,
                          color: chip.textColor,
                          fontWeight: 600,
                          fontSize: "18px",
                          borderRadius: "10px",
                          padding: "6px 14px !important",
                          margin: "0 4px",
                          display: "inline-flex"
                        }}
                      />
                      
                      <Box component="span" dangerouslySetInnerHTML={{ __html: discussionText[index + 1] }}/>
                    </React.Fragment>
                  ))}
                </Typography>
              </Stack>
              {showButton && (
                              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" justifyContent="center">
                      <Button
                        href={buttonHref}
                        variant={buttonVariant}
                      >
                        {buttonText}
                      </Button>
                      </Stack>
                  )}
            </Stack>
            {displayIcons && <Stack sx={{
                display: "flex",
                gap: "22px",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                alignContent: "center",
            }}>
                <Box component="img"
                    src={first}
                    alt="UI customization"
                    sx={{
                        aspectRatio: "1/1",
                        objectFit: "contain",
                        objectPosition: "center",
                        alignSelf: "center",
                        margin: "0 auto",
                        flexShrink: 0,
                        width: {xs: "33px", md: "36px"},
                        height: {xs: "33px", md: "36px"},
                    }}
                />
                <Box component="img"
                    src={second}
                    alt="Design options"
                    sx={{
                        aspectRatio: "1/1",
                        objectFit: "contain",
                        objectPosition: "center",
                        alignSelf: "center",
                        margin: "0 auto",
                        flexShrink: 0,
                        width: {xs: "49.5px", md: "54px"},
                        height: {xs: "49.5px", md: "54px"},
                    }}
                />
                <Box component="img"
                    src={third}
                    alt="Brand integration"
                    sx={{
                        aspectRatio: "1/1",
                        objectFit: "contain",
                        objectPosition: "center",
                        alignSelf: "center",
                        margin: "0 auto",
                        flexShrink: 0,
                        width: {xs: "52px", md: "56px"},
                        height: {xs: "52px", md: "56px"},
                    }}
                />
                <Box component="img"
                    src={second}
                    alt="UX optimization"
                    sx={{
                        aspectRatio: "1/1",
                        objectFit: "contain",
                        objectPosition: "center",
                        alignSelf: "center",
                        margin: "0 auto",
                        flexShrink: 0,
                        width: {xs: "49.5px", md: "54px"},
                        height: {xs: "49.5px", md: "54px"},
                    }}
                />
                <Box component="img"
                    src={first}
                    alt="Custom development"
                    sx={{
                        aspectRatio: "1/1",
                        objectFit: "contain",
                        objectPosition: "center",
                        alignSelf: "center",
                        margin: "0 auto",
                        flexShrink: 0,
                        width: {xs: "33px", md: "36px"},
                        height: {xs: "33px", md: "36px"},
                    }}
                />
            </Stack>}
          </Stack>
        </Stack>
      </Box>
    );
  };

  export default HeadingWithChips;